import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export function ConfirmDelete({ title, text, onConfirm, testId, label = "Elimina", small }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button data-testid={testId} className={`press flex items-center gap-1.5 rounded-md text-sm font-semibold text-rose-700 border border-rose-200 hover:bg-rose-50 ${small ? "h-8 px-2" : "h-10 px-4"}`}>
          <Trash2 className="w-4 h-4" /> {!small && label}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{text}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Annulla</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={onConfirm} className="bg-rose-700 hover:bg-rose-800">Elimina definitivamente</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export const inp = "w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-yellow/70";

export function Field({ label, children, wide }) {
  return <label className={`block text-xs space-y-1 ${wide ? "sm:col-span-2" : ""}`}><span className="text-slate-600">{label}</span>{children}</label>;
}
